/** A fresh correlation id for one request (`X-Request-Id`). */
export function newRequestId(): string {
  const c = globalThis.crypto
  if (c?.randomUUID) return c.randomUUID()
  const b = new Uint8Array(16)
  if (c?.getRandomValues) c.getRandomValues(b)
  else for (let i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256)
  b[6] = (b[6] & 0x0f) | 0x40
  b[8] = (b[8] & 0x3f) | 0x80
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("")
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`
}

/** The server's `X-Request-Id` carried by an error, if any. */
export function requestIdOf(err: unknown): string | undefined {
  const id = (err as { requestId?: unknown } | null)?.requestId
  return typeof id === "string" && id ? id : undefined
}

/** `message` plus "Reference: <id>" when the error carries a request id. */
export function withReference(message: string, err: unknown): string {
  const id = requestIdOf(err)
  return id ? `${message} Reference: ${id}` : message
}

// The X-Request-Id of the latest turn POST per thread. It is the id the server's telemetry
// knows the turn by, so feedback on that turn carries it (a reloaded turn has none).
const lastTurnRequest = new Map<string, string>()
export const noteTurnRequestId = (threadId: string, id: string): void => void lastTurnRequest.set(threadId, id)
export const lastTurnRequestId = (threadId: string): string | undefined => lastTurnRequest.get(threadId)
